// extracted by mini-css-extract-plugin
export default {"link":"_3eQ7O"};